import React, { useState } from "react";
import { CURRENCY } from "../../../../../../constants/storageKeys";
import {
  FieldContainer,
  GiantHeader,
  LogBox,
  LogBoxWrapper
} from "../../style";
import Variables from "../../../../../../assets/styleVariables";
import BudgetIcon from "../../../../../../projectSpecificComponents/svgIcons/budget/report";
import ViewIcon from "../../../../../../projectSpecificComponents/svgIcons/view";

const Index = ({ budget }) => {
  const [showBudgetPart, toggleBudgetPart] = useState(true);
  return (
    <React.Fragment>
      {budget && budget.has_budget && (
        <LogBoxWrapper>
          <div>
            <GiantHeader
              open={showBudgetPart}
              onClick={() => toggleBudgetPart(!showBudgetPart)}
            >
              <span className="right-part">
                <span className="icon-container">
                  <BudgetIcon
                    color={Variables.colors.primary_vivid}
                    size={20}
                  />
                </span>
                <span>اطلاعات بودجه‌بوندی</span>
              </span>
              <i className="arrow-icon icon mapsa-left-arrow" />
            </GiantHeader>

            <LogBox show={showBudgetPart}>
              <FieldContainer group borderLess>
                <div className="group">
                  <span className="label">کل هزینه‌های این تنخواه</span>
                  <span className="value">
                    {parseInt(budget.payment_sum).toLocaleString("fa")}
                    <span className="unit">
                      ({localStorage.getItem(CURRENCY)})
                    </span>
                  </span>
                </div>
                <div className="group">
                  <span className="label">جمع بودجه این تنخواه</span>
                  <span className="value">
                    {parseInt(budget.budget_sum).toLocaleString("fa")}

                    <span className="unit">
                      ({localStorage.getItem(CURRENCY)})
                    </span>
                  </span>
                </div>
                <div className="group">
                  <span className="label bold">انحراف بودجه</span>
                  <span className="value bold">
                    {parseInt(budget.deviation).toLocaleString("fa")}
                    <span className="unit">
                      ({localStorage.getItem(CURRENCY)})
                    </span>
                  </span>
                </div>
              </FieldContainer>
            </LogBox>
          </div>
        </LogBoxWrapper>
      )}
    </React.Fragment>
  );
};

export default Index;
